import {
  observable,
  action
} from 'mobx';
import {
  message
} from 'antd';
import {
  getAppDatas
} from '../../api/list';
import base from '../../tool/base';
import util from '../../util/index';

const {
  catchApiError,
  getAccessToken,
  isCus,
  getEcId,
} = util;

export class ModeListStore {

  routing = null;

  constructor(routing) {
    this.routing = routing;
  }

  @observable loading = false;
  @observable current = 1;
  @observable pageSize = 24;
  @observable appHotSelected = '';
  @observable modeList = [];
  @observable modeCount = 0;
  @observable type = 1; //1.热度, 2.发布日期, 3.更新日期
  @observable visible = false;
  @observable genre = []; //行业分类
  @observable modeType = 'ea393802-8f4a-4ef0-a4e2-6fe4915cb8c7';
  @observable indType = 'all';
  @observable appType = 'all';
  @observable appDetail = {};
  @observable cusList = [];
  @observable cusCount = 0;
  @observable cusCurrent = 0;
  @observable isApply = false;
  @observable visibleOfApply = false;
  @observable buyAppResult = {};
  @observable tz = false;
  @observable formLoading = false;
  @observable collectList = [];
  @observable collectCount = [];
  @observable orderServerList = [];
  @observable searchType = 'workflow'; //全部应用搜索页面 当前选中版块
  @observable modules = [];
  @observable isKbStatus = true;

  @action
  setMobxState = (params = {}) => {
    Object.keys(params).forEach(key => {
      this[key] = params[key];
    });
    return this;
  }
  @action
  init = () => {
    this.current = 1;
    this.pageSize = 24;
    this.appHotSelected = '';
    this.modeList = [];
    this.modeCount = 0;
  }

  @action
  getMould = (id) => {
    if (id === 'mode') return 'ea393802-8f4a-4ef0-a4e2-6fe4915cb8c7';
    else if (id === 'dev') return 'c2ad5184-3e3e-431f-947e-67ae3a960b59';
    else if (id === 'nStandard') return '5058eb5e-8087-4c0d-8a64-3fa600862c02';
    return this.searchType;
  }

  @action
  getModeList = (params = {}) => {
    this.loading = true;
    const param = {
      ...params,
      type: params.type || this.type,
      current: params.current || this.current,
      pageSize: params.pageSize || this.pageSize,
      access_token: getAccessToken(),
      module: params.module || this.modeType,
      ind: params.ind || this.indType,
      apptype: params.appType || this.appType,
    };
    if (param.ind === 'all') delete param.ind; //全部选项
    if (param.apptype === 'all') delete param.apptype; //全部选项
    return new Promise(resolve => {
      getAppDatas(param).then(data => catchApiError(data, this.routing)).then(data => {
        if (data.status === 'true') {
          if (param.current === 1) {
            this.modeList = data.apps;
          } else {
            this.modeList = this.modeList.concat(data.apps);
          }
          this.modeCount = data.count;
          this.loading = false;
        } else {
          message.error(data.msg);
        }
        resolve(data);
      })
    });
  }
  @action
  getGenre = (params = {}) => {
    const param = {
      ...params,
      type: 'y',
      gorder: 0,
      access_token: getAccessToken(),
    };
    return new Promise(resolve => {
      base.callApi('/v1.1/sys/genre', 'GET', param, 'json', 'text').then(data => catchApiError(data, this.routing)).then((data => {
        if (data.status === 'true') {
          this.genre = data.genre;
        }
        resolve(data);
      }));
    });
  }
  @action
  callCollect = (params = {}) => {
    const param = {
      access_token: getAccessToken(),
      cloudStore: 1,
      ...params,
    };
    return new Promise(resolve => {
      base.callApi('/v3/appcollect/edit4batch', 'POST', param, 'json', 'text').then(data => catchApiError(data, this.routing)).then((data) => {
        message.config({
          top: 20,
        });
        if (data.status === 'true') {
          message.success(param.collect === '0' ? '收藏成功' : '取消成功');
          resolve(data);
        } else {
          message.success(param.collect === '0' ? '收藏失败' : '取消失败');
        }
      });
    });
  }

  @action
  getAppDetail = (params = {}) => {
    const param = {
      access_token: getAccessToken(),
      type: 'get',
    };
    return new Promise(resolve => {
      base.callApi(`/v1/app/${params.id}`, 'POST', param, 'json', 'text').then(data => catchApiError(data, this.routing)).then((data) => {
        if (data.status !== 'false') {
          this.appDetail = data;
          resolve(data);
        }
      });
    });
  }

  @action
  getDeV2 = (params = {}) => {
    if (!isCus()) {
      const param = {
        access_token: getAccessToken(),
        pageNum: params.current || 1,
        pageSize: params.pageSize || 10,
        key: params.search || '',
        ec_id: getEcId(),
      };
      return new Promise(resolve => {
        base.callApi('/v5/crm/crmList', 'GET', param, 'json', 'text').then(data => catchApiError(data, this.routing)).then((data) => {
          if (data.status) {
            this.cusList = data.list;
            this.cusCount = data.count;
            this.cusCurrent = params.current;
            resolve(data.list);
          } else {
            this.cusList = [];
            this.cusCount = 0;
            this.cusCurrent = 1;
            resolve();
          }
        });
      });
    }
  }

  @action
  getLicense = (params = {}) => {
    const param = {
      access_token: getAccessToken(),
      ...params,
    };
    return new Promise(resolve => {
      base.callApi('/v2/license', 'POST', param, 'json', 'text').then(data => catchApiError(data, this.routing)).then((data) => {
        if (data.status === 'true') {
          resolve(data.datas);
        }
      });
    });
  }

  @action
  applyLicense = (params = {}) => {
    const param = {
      access_token: getAccessToken(),
      ...params,
    };
    return new Promise(resolve => {
      base.callApi('/v2/applyLicense', 'POST', param, 'json', 'text').then(data => catchApiError(data, this.routing)).then((data) => {
        this.isApply = data.status === '1';
        resolve(data.datas);
      });
    });
  }

  @action
  buyApp = (params = {}) => {
    this.formLoading = true;
    const param = {
      access_token: getAccessToken(),
      order: JSON.stringify(params),
    };
    return new Promise(resolve => {
      base.callApi('/v2/order/add', 'POST', param, 'json', 'text').then(data => catchApiError(data, this.routing)).then((data) => {
        if (data.status === 'true') {
          this.buyAppResult = data;
          this.isApply = true;
          this.applyLicense({
            sw_id: params.sw_id,
            ec_id: params.c_id,
            c_id: params.c_id,
            ecname: params.c_name,
            license: params.license,
          });
          resolve(data);
        }
        message.info(data.status == "true" ? "申请成功" : "申请失败");
        this.formLoading = false;
      });
    });
  }

  @action
  setDownLoad = (params = "") => {
    const param = {
      access_token: getAccessToken(),
    };
    return new Promise(resolve => {
      base.callApi('/v1/order/' + params, 'GET', param, 'json', 'text').then(data => catchApiError(data, this.routing)).then((data) => {
        if (data.status === 'true') {
          resolve(data);
        }
      });
    });
  }

  @action
  getCollectList = (params = {}) => {
    const param = {
      ...params,
      current: params.current || this.current,
      pageSize: params.pageSize || this.pageSize,
      collect: 0,
      access_token: getAccessToken(),
    };
    return new Promise(resolve => {
      base.callApi('/v1/appCon', 'GET', param, 'json', 'text').then(data => catchApiError(data, this.routing)).then((data) => {
        if (data.status === 'true') {
          this.collectList = data.apps;
          this.collectCount = data.count;
          resolve(data);
        }
      });
    });
  }

  @action
  buyV2 = (params = {}) => {
    const param = {
      ...params,
      access_token: getAccessToken(),
    };
    return new Promise(resolve => {
      base.callApi('/v1/buyV2', 'GET', param, 'json', 'text').then(data => catchApiError(data, this.routing)).then((data) => {
        if (data.status === 'true') {
          this.orderServerList = data.list;
          resolve(data);
        }
      });
    });
  }

  @action
  getModules = (params = {}) => {
    const param = {
      ...params,
      type: 'n',
      gorder: 0,
      access_token: getAccessToken(),
    };
    const filterKeys = ['ea393802-8f4a-4ef0-a4e2-6fe4915cb8c1', 'f16df3ff-ca94-40c2-89ee-7426b95b55fa', 'ea393802-8f4a-4ef0-a4e2-6fe4915cb8c7', '7429b7e4-1840-400c-9d32-c99f8ad2a939'
      , 'c2ad5184-3e3e-431f-947e-67ae3a960b59', '5058eb5e-8087-4c0d-8a64-3fa600862c02'];
    return new Promise(resolve => {
      base.callApi('/v1.1/sys/genre', 'GET', param, 'json', 'text').then(data => catchApiError(data, this.routing)).then((data => {
        let modules = [];
        if (data.status === 'true') {
          modules = data.genre.filter(v => filterKeys.indexOf(v.key) < 0);
          this.modules = modules;
        }
        resolve({modules, data});
      }));
    });
  }

}


// WEBPACK FOOTER //
// ./src/stores/modeList/index.js